/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction, Slice } from '@reduxjs/toolkit';
import { APP_CONTEXT_API } from 'services/constants';
import { ContextResponse } from 'services/types';
import { isApiFetchingCompletedAction } from '../utils';

const isContextsApiFullfilledAction =
  isApiFetchingCompletedAction(APP_CONTEXT_API);

export interface ContextsState {
  contexts: string[] | undefined;
  selectedContext: string;
}

const initialState: ContextsState = {
  contexts: [],
  selectedContext: '',
};

export const contextsSlice: Slice<ContextsState> = createSlice({
  name: 'contextsSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      isContextsApiFullfilledAction,
      (state, action: PayloadAction<ContextResponse[]>) => {
        const { payload } = action;
        state.contexts = payload.map((context) => context.context);
        if (payload && payload.length > 0)
          state.selectedContext = payload[0]?.context;
      }
    );
  },
});
